import './bootstrap';
import './header';
import './contact';
// import './authentication';
import './common';
import './fixedButton';
import './language-selector';
// import './carousels-init'; // DESACTIVADO: Cada componente tiene su propio JS inline
import AOS from 'aos';
import 'aos/dist/aos.css';

// Inicializar AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false,
  offset: 150, // Animar cuando el elemento esté a 400px de entrar al viewport
  disable: false,
});


